import { Button } from '@mantine/core';
import { IconCalendarEvent } from '@tabler/icons-react';

interface BookingButtonProps {
  text?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'filled' | 'light' | 'outline' | 'subtle' | 'default';
  fullWidth?: boolean;
  className?: string;
}

export function BookingButton({ 
  text = "Book tid", 
  size = "md", 
  variant = "filled",
  fullWidth = false,
  className = ""
}: BookingButtonProps) {
  return (
    <Button
      component="a"
      href="https://lykke-terapien.planway.com/"
      target="_blank"
      rel="noopener noreferrer"
      size={size}
      variant={variant}
      fullWidth={fullWidth}
      leftSection={<IconCalendarEvent size={18} />}
      className={className}
    >
      {text}
    </Button>
  );
}